import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appDnd]',
  standalone: false,
})
export class DndDirective {
  @HostBinding('class.fileover') fileOver!: boolean;
  @Output() fileDropped = new EventEmitter<FileList | never[]>();

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    const files = evt?.dataTransfer?.files || [];
    const isValidFileType = this.isValidFileType(files[0].name, [
      '.csv',
      '.txt',
    ]);
    if (files.length > 0 && isValidFileType) {
      this.fileDropped.emit(files);
    }
  }

  isValidFileType(fileName: string, allowedExtensions: string[]): boolean {
    return allowedExtensions.some((ext) => fileName.endsWith(ext));
  }
}
